// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export {};

throw new Error(
  'The patch-eslint6.js script has been rewritten to support both ESLint 6.x and 7.x.' +
    ' Please update your ESLint configuration to use this path instead:\n\n' +
    '  require("@rushstack/eslint-config/patch/modern-module-resolution");'
);
